<template>
  <bb-button variant="outlined" class="w-full !px-24 py-12" @click="handleClick">
    <div
      class="dark:text-gray-10 flex h-full w-full flex-nowrap items-center justify-center gap-8 font-semibold text-gray-900"
    >
      <font-awesome-icon :icon="icon" class="!h-20 w-20" />
      <div class="text-17">
        {{ t(`${authType}.providerText`, { provider: authProvider }) }}
      </div>
    </div>
  </bb-button>
</template>

<script lang="ts" setup>
import { type IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const props = defineProps<{
  provider: AuthProvider;
  icon: IconDefinition;
  authType: AuthType;
}>();

const emit = defineEmits<{
  (e: 'provider-click', provider: OAuthProvider): void;
  (e: 'email-click'): void;
}>();

const { t } = useI18n();
const route = useRoute();

const { isConsentGiven } = useCookieControl();

const handleClick = () => {
  if (!isConsentGiven.value && route.name === 'login') {
    useNotificationBanner(t('login.error.cookieConsentRequired'), 'error');
    return;
  }
  if (props.provider === 'email') emit('email-click');
  else emit('provider-click', props.provider as OAuthProvider);
};

const authProvider = computed(() => {
  switch (props.provider) {
    case 'github':
      return 'GitHub';
    case 'google':
      return 'Google';
    case 'email':
      return 'Email';
  }
});
</script>
